import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BaseHttpService } from "./base-http.service";
import { environment } from "../../../environments/environment";
import { LiveQuizFilterModel } from "../../shared/models/common.model";
import { ILiveQuizRegisterModel, ILiveQuizDetailModel, ILiveQuizModel, ILiveQuizPagedResult, ILiveQuizResultResponseModel, ILiveQuizSectionListModel, ITopRankersModel } from "../../shared/models/live-quiz.model";
import { NotificationHubStateService } from "../states/notification-hub.state.service";

@Injectable({
    providedIn: 'root'
})
export class LiveQuizService extends BaseHttpService {

    apiBaseUrl = environment.apiBaseUrl;

    constructor(private readonly notificationHub: NotificationHubStateService) {
        super();
    }

    recentComingEvents(): Observable<ILiveQuizModel[]> {
        return this.http.get<ILiveQuizModel[]>(`${this.apiBaseUrl}Quiz/RecentComingEvents`);
    }

    getUpcomingLiveQuiz(filterModel: LiveQuizFilterModel): Observable<ILiveQuizPagedResult> {
        return this.http.get<ILiveQuizPagedResult>(`${this.apiBaseUrl}Quiz/GetUpcomingEvents?${filterModel.toQueryString()}`);
    }

    registerForLiveQuiz(model: ILiveQuizRegisterModel): Observable<string> {

        return this.http.post<string>(`${this.apiBaseUrl}Quiz/Register`, model);
    }

    liveQuizStart(liveQuizId: string): Observable<ILiveQuizDetailModel> {
        return this.http.get<ILiveQuizDetailModel>(`${this.apiBaseUrl}Quiz/LiveQuizStart/${liveQuizId}`);
    }

    getLiveQuizSections(liveQuizId: string): Observable<ILiveQuizSectionListModel> {
        return this.http.get<ILiveQuizSectionListModel>(`${this.apiBaseUrl}Quiz/GetLiveQuizSections/${liveQuizId}`,
            {
                headers: {
                    'X-SignalR-ConnectionId': this.notificationHub.signalRConnectionId ?? ''
                }
            });
    }

    getLiveQuizResult(liveQuizId: string): Observable<ILiveQuizResultResponseModel> {
        return this.http.get<ILiveQuizResultResponseModel>(`${this.apiBaseUrl}Quiz/LiveQuizResult/${liveQuizId}`);
    }

    getRemoveLiveQuizConnection(liveQuizId: string): Observable<boolean> {
        return this.http.get<boolean>(`${this.apiBaseUrl}Quiz/RemoveLiveQuizConnection/${liveQuizId}`);
    }

    getLiveQuizTopRankersResult(liveQuizId: string): Observable<ITopRankersModel[]> {
        return this.http.get<ITopRankersModel[]>(`${this.apiBaseUrl}Quiz/LiveQuizTopRankResults/${liveQuizId}`);
    }
}